import { render, staticRenderFns } from "./round-info.vue?vue&type=template&id=0253d48c&scoped=true"
import script from "./round-info.vue?vue&type=script&lang=js"
export * from "./round-info.vue?vue&type=script&lang=js"
import style0 from "./round-info.vue?vue&type=style&index=0&id=0253d48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253d48c",
  null
  
)

export default component.exports